import stringToNumber from "src/utils/stringToNumber";
import yup from "src/utils/yup/extensionMethods";

const deleteSchema = (translate: Function) => yup.object().shape({
	oka001Titulo: yup.string().required(translate("Titulo do OKR não confere")).oneOf([yup.ref("oka001TituloConfirmation")], translate("Titulo do OKR não confere"))
});

const Targets = (translate: Function, language:string) => yup.object().shape({
	oka002Cor: yup.string().required(translate("Cor da faixa é requerida")),
	oka002Valorini: yup.number()
		.transform((value,originalValue) => typeof originalValue !== "string" ? value : stringToNumber(originalValue,language))
		.required(translate("Valor inicial a faixa é requerida"))
		.typeError(translate("Valor inicial está incorreto")),
	oka002Valorfim:yup.number()
		.transform((value,originalValue) => typeof originalValue !== "string" ? value : stringToNumber(originalValue,language))
		.required(translate("Valor final da faixa é requerida"))
		.typeError(translate("Valor final está incorreto"))
		.when("oka002Valorini",(initiaValue,schema) => initiaValue ? schema.min(initiaValue,translate("Valor inicial não pode ser menor que o final")):schema)
});

const addOrChangeSchema = (translate: Function, language:string) => yup.object().shape({
	oka001Titulo: yup.string().required(translate("Título é requerido")),
	oka001Dtinicio: yup.date().nullable().required(translate("Data Inicial é requerida")),
	oka001Dtfim: yup.date().nullable().required(translate("Data Final é requerida")).min(
		yup.ref("oka001Dtinicio"),
		translate("Data Final tem que ser após a Data Inicial")
	),
	oka001Efa005Id: yup.string().required(translate("Responsável é requerido")),
	oka001Efa005Id2: yup.string().required(translate("Autoridade é requerido")),
	oka001Missao: yup.string(),
	oka001Nivel: yup.string().required(translate("Nível é requerido")),
	oka001Tags: yup.array().of(yup.string()),
	oktba002: yup.array().of(Targets(translate,language)).min(1,translate("Ao menos uma faixa deve ser informada")),
	oktba006: yup.array().of(yup.object().shape({
		oka006Id: yup.string(),
		oka006Notificaparticipante: yup.string(),
		oka006Tipo: yup.string(),
		oka006Efa005Id: yup.string(),
		oka006Efa004Id: yup.string()
	}))
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.oka006Efa005Id, (a: any) => !a.oka006Efa004Id && a.oka006Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.oka006Efa005Id, (a: any) => !a.oka006Efa004Id && a.oka006Tipo === "I")
		.unique(translate("Consultados não podem ser repetidos"), (a: any) => a.oka006Efa004Id, (a: any) => !a.oka006Efa005Id && a.oka006Tipo === "C")
		.unique(translate("Informados não podem ser repetidos"), (a: any) => a.oka006Efa004Id, (a: any) => !a.oka006Efa005Id && a.oka006Tipo === "I")
});

export { deleteSchema, addOrChangeSchema };
